import React, { useEffect, useState } from 'react';
import './Home.css';
import Areas from '../../components/Areas/Areas';
import { useStore } from '../../store/Store';
import { fetchData } from '../../store/ActionProgramas';
import PageError from '../../components/PageError';
import { IntroLogo } from '../../components/IntroLogo';
import { Hero } from '../../components/hero';

const Home = () => {
  const {
    state: { programas, loading },
    dispatch,
  } = useStore();

  const [videoLoading, setVideoLoading] = useState(true);

  useEffect(() => {
    console.log(videoLoading);
    programas.length === 0 && fetchData(dispatch);
  }, []);

  /**
   * Lauch video intro
   * When the video finish, he make a callback to setVideoLoading in order to update videoLoading = false
   */
  const onLoad = () => {
    return <IntroLogo isOpen={videoLoading} setOpen={setVideoLoading} />;
  };

  const fillContent = () => {
    if (videoLoading) return onLoad();

    if (!programas && !loading)
      return <PageError error="No se pudieron obtener los programas." />;

    return (
      <>
        <article>
          <Areas loading={loading} programas={programas} />
        </article>
      </>
    );
  };

  return <>{fillContent()}</>;
};

export default Home;
